import i18n from "config/i18next";

i18n.addResources("es", "tablePresettlements", {
  preliNumber: "Nro. de preliquidación",
  if: "Identificador fiscal",
  pickerId: "Id del picker",
  dateOfIssue: "Generación",
  status: "Estado",
  total: "Total",
});
